export const isCustomEvent = <T = any,>(event: Event): event is CustomEvent<T> => {
  return "detail" in event;
};
